
import { mapState, mapGetters } from 'vuex';
import SocialMediaType from '@/enums/SocialMediaType';
import formatRelativeDate from '@/lib/relativeDate';
import AppReviewUserInfoSectionUserDisplay from '@/components/common/AppReviewUserInfoSection/AppReviewUserInfoSectionUserDisplay';
import AppSocialMediaIcon from '@/components/common/AppSocialMediaIcon';
import AppVideoPlayIcon from '@/components/common/AppVideoPlayIcon';
import AppMediaCountIcon from '@/components/common/AppMediaCountIcon';

export default {
  name: 'AppReviewOverlayInfoVertical',
  components: {
    AppReviewUserInfoSectionUserDisplay,
    AppSocialMediaIcon,
    AppVideoPlayIcon,
    AppMediaCountIcon
  },
  props: {
    review: {
      type: Object,
      required: true
    },
    video: {
      type: Object,
      default: null
    },
    videoUrl: {
      type: String,
      default: null
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('widget', ['widget']),
    ...mapGetters('widget', ['isMobileViewport']),
    relativeDate() {
      if (!this.review.created_at) return '';

      return formatRelativeDate(this.review.created_at);
    },
    isSocialMediaType() {
      return this.review.social_media_type !== SocialMediaType.NONE;
    },
    showVerticalSocialMediaIcon() {
      if (!this.isSocialMediaType) return false;
      return ![SocialMediaType.FACEBOOK, SocialMediaType.VIMEO].includes(
        this.review.social_media_type
      );
    },
    showVerticalVideoPlayIcon() {
      if (this.showVerticalSocialMediaIcon) return false;
      if (!this.video) return false;
      return !this.reviewSettings.thumbnail_video_autoplay || !this.videoUrl;
    },
    showVerticalMediaCountIcon() {
      if (this.compact) return false;
      if (this.showVerticalSocialMediaIcon) return false;
      if (this.showVerticalVideoPlayIcon) return false;
      return this.review.media_count > 1;
    }
  }
};
